import React, { useEffect, useState } from "react";
import type { ViewsConfiguration, BackgroundOptions } from '../../../model/Configuration';
import { useViewsConfiguration } from '../../../redux/Hooks/';
import { viewsConfigurationChangeAction } from "../../../redux/Actions";
import { useDispatchKiosk } from "../../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../../translations/subMenuItems.json'
import commonTranslation from '../../../translations/common.json'
import Button from "../../Common/Button";
import TextField from "./../TextField";
import tempViewsConfigurationChangeAction from "../../../redux/Actions/Kiosk/tempViewsConfigurationChangeAction";

const Image = (props: { from: string }) => {
  const locale = useLocale();
  const viewsConfiguration: ViewsConfiguration = useViewsConfiguration();
  const dispatch = useDispatchKiosk();

  const [url, setUrl] = useState<string>(viewsConfiguration.views[props.from]?.background?.image || '');
  const [changed, setChanged] = useState<boolean>(false);

  useEffect(() => {
    setChanged(true);
  }, [url])

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    setUrl(event.currentTarget.value);
  }

  const handleApply = () => {
    try {
      const tempData = { ...viewsConfiguration };
      const from = props.from;
      const background: BackgroundOptions = {
        ...viewsConfiguration.views[from].background,
        style: 'image',
        image: url
      }

      tempData.views[from].background = background;

      dispatch(viewsConfigurationChangeAction(tempData));
      dispatch(tempViewsConfigurationChangeAction(from === 'home' ?
        {
          home: {
            background: {
              style: 'image',
              image: url
            }
          }
        } : {
          news: {
            background: {
              style: 'image',
              image: url
            }
          }
        }));
      setChanged(false);
    } catch(error) {
      console.log(error);
    }
  }

  return (
    <div className="w-full flex flex-col gap-1 my-1 px-4">
      <TextField
        label={translation[locale]?.background.imageurl || translation["fr-FR"].background.imageurl}
        onChange={handleChange}
        value={url}
      />
      {changed &&
        <div className="flex justify-center mt-1">
          <Button
            onClick={handleApply}
            label={commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          >
            {commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
          </Button>
        </div>
      }
    </div>
  );
};

export default Image;
